import React from 'react';
import useCurrencyConverter from '../../../hooks/params/useCurrencyConverter';
import { CalculadoraBCVModal } from './CalculadoraBCVModal';
import { CalculatorIcon } from './icons';
import './CalculadoraBCV.scss';

/**
 * FloatingCalculadoraBCV
 * ---------------------------------------------------------------------------
 * Botón flotante global (FAB) + modal de la Calculadora BCV.
 * Conecta el custom hook `useCurrencyConverter` con el componente de
 * presentación. Diseñado para montarse una sola vez en el layout principal
 * (App.js) y quedar persistente en todas las vistas del sistema.
 */
export const FloatingCalculadoraBCV = () => {
  const {
    isOpen,
    openModal,
    closeModal,
    paymentDate,
    handlePaymentDateChange,
    rateFormatted,
    isLoadingRate,
    usdAmount,
    handleUsdAmountChange,
    bsAmountFormatted,
    handleCopyToClipboard,
    copied,
  } = useCurrencyConverter();

  return (
    <>
      <button
        type="button"
        className="bcv-fab"
        onClick={openModal}
        aria-label="Abrir calculadora BCV"
        title="Calculadora BCV"
      >
        <CalculatorIcon />
      </button>

      <CalculadoraBCVModal
        isOpen={isOpen}
        onClose={closeModal}
        paymentDate={paymentDate}
        onPaymentDateChange={handlePaymentDateChange}
        rateFormatted={rateFormatted}
        isLoadingRate={isLoadingRate}
        usdAmount={usdAmount}
        onUsdAmountChange={handleUsdAmountChange}
        bsAmountFormatted={bsAmountFormatted}
        onCopy={handleCopyToClipboard}
        copied={copied}
      />
    </>
  );
};

export default FloatingCalculadoraBCV;
